import { Euler } from 'three'
import { createSelector } from 'reselect'
import { RootState } from '@tabeeb/store'

export const getIsDrawingEnabled = (state: RootState) => state.playerToolbar.drawing.drawingState.isDrawing
export const getDrawingAnnotationType = (state: RootState) => state.playerToolbar.drawing.drawingState.type
export const getViewerBackground = (state: RootState) => state.pointCloud.viewer.background
export const getSelectedModel = (state: RootState) => state.pointCloud.selectedModel
export const getFieldOfView = (state: RootState) => state.pointCloud.viewer.fieldOfView
export const getPointSize = (state: RootState) => state.pointCloud.viewer.pointSize
export const getUnit = (state: RootState) => state.pointCloud.settings.unit
export const getPageSettings = (state: RootState) => state.pointCloud.settings.pageSettings
export const getScale = (state: RootState) => state.pointCloud.settings.pageSettings.MeasurementsScaleFactor
export const getIsSourcePagesNavigationEnabled = (state: RootState) => state.pointCloud.navigation

export const getWorldRotation = createSelector([(state) => state.pointCloud.rotation], (rotation) => {
  return new Euler(rotation.x, rotation.y, rotation.z)
})

export const getWorldRotationCompensation = createSelector([getWorldRotation], (rotation) => {
  return new Euler(-rotation.x, -rotation.y, -rotation.z)
})

export const getTransformationState = (state: RootState) => state.pointCloud.transformation
